<div class="h-full min-h-0 overflow-x-clip overflow-y-auto">
  @if (cargando()) {
    <div class="space-y-3">
      <div class="h-40 animate-pulse rounded-2xl bg-slate-100"></div>
      <div class="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-3">
        @for (i of [1, 2, 3, 4, 5, 6]; track i) {
          <div class="h-32 animate-pulse rounded-xl bg-slate-100"></div>
        }
      </div>
    </div>
  } @else {
    <div class="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm sm:p-5">
      <div class="flex flex-wrap items-center gap-3">
        <div class="rounded-xl bg-accent-50 p-3 text-accent-600">
          <i class="bi bi-phone text-xl"></i>
        </div>

        <div class="min-w-0 flex-1 basis-52">
          <div class="flex flex-wrap items-center gap-2">
            <h2 class="text-base font-bold text-slate-900 sm:text-lg">Carta digital</h2>
            @if (config()?.publicado) {
              <app-tag value="Publicada" severity="success" icon="bi bi-globe" />
            } @else {
              <app-tag value="Borrador" severity="secondary" icon="bi bi-pencil" />
            }
          </div>
          <p class="mt-0.5 truncate text-sm text-slate-500">
            {{ empresaNombre() }} · {{ productosVisibles() }} de {{ productos().length }} productos visibles
          </p>
        </div>

        <div class="flex gap-2">
          <app-button
            label="Copiar enlace"
            icon="bi bi-link-45deg"
            variant="secondary"
            size="sm"
            [disabled]="!enlacePublico()"
            (onClick)="copiarEnlace()"
          />
          <span [title]="config()?.publicado ? 'Abrir carta pública' : 'Publica la carta para abrirla'">
            <app-button
              label="Ver carta"
              icon="bi bi-box-arrow-up-right"
              variant="primary"
              size="sm"
              [disabled]="!enlacePublico() || !config()?.publicado"
              (onClick)="abrirCarta()"
            />
          </span>
        </div>
      </div>

      @if (enlacePublico()) {
        <button
          type="button"
          class="mt-3 flex w-full items-center gap-2 truncate rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-left text-sm text-slate-600 transition hover:border-slate-300"
          (click)="copiarEnlace()"
          title="Copiar enlace"
        >
          <i class="bi bi-link-45deg shrink-0 text-slate-400"></i>
          <span class="truncate">{{ enlacePublico() }}</span>
          <i class="bi bi-clipboard ml-auto shrink-0 text-slate-400"></i>
        </button>
      } @else {
        <p class="mt-3 rounded-lg bg-amber-50 px-3 py-2 text-sm leading-relaxed text-amber-700">
          <i class="bi bi-info-circle mr-1"></i>
          Guarda la configuración para generar el enlace público de tu carta.
        </p>
      }

      @if (enlacePublico() && !config()?.publicado) {
        <p class="mt-2 rounded-lg bg-amber-50 px-3 py-2 text-xs leading-relaxed text-amber-700">
          <i class="bi bi-eye-slash mr-1"></i>
          La carta está en borrador. Activa “Carta publicada” y guarda para que tus clientes puedan verla.
        </p>
      }

      <div class="mt-3 grid grid-cols-2 gap-2 sm:grid-cols-4 sm:gap-3">
        <div class="rounded-lg bg-slate-50 px-3 py-2 text-center">
          <p class="text-base font-bold text-slate-900 sm:text-lg">{{ productosVisibles() }}</p>
          <p class="text-[11px] font-medium uppercase tracking-wide text-slate-500">visibles</p>
        </div>
        <div class="rounded-lg bg-slate-50 px-3 py-2 text-center">
          <p class="text-base font-bold text-slate-900 sm:text-lg">{{ categoriasVisibles() }}</p>
          <p class="text-[11px] font-medium uppercase tracking-wide text-slate-500">categorías</p>
        </div>
        <div class="rounded-lg bg-slate-50 px-3 py-2 text-center">
          <p class="text-base font-bold text-slate-900 sm:text-lg">{{ moneda(configModel().pedido_minimo) }}</p>
          <p class="text-[11px] font-medium uppercase tracking-wide text-slate-500">pedido mín.</p>
        </div>
        <div class="rounded-lg bg-slate-50 px-3 py-2 text-center">
          <p
            class="truncate text-base font-bold sm:text-lg"
            [class.text-amber-600]="deliveryResumen() === 'A coordinar'"
            [class.text-slate-900]="deliveryResumen() !== 'A coordinar'"
          >
            {{ deliveryResumen() }}
          </p>
          <p class="text-[11px] font-medium uppercase tracking-wide text-slate-500">delivery</p>
        </div>
      </div>
    </div>

    <app-tabs
      [tabs]="tabsList"
      [activeTab]="tab()"
      (activeTabChange)="tab.set($event)"
      styleClass="mt-4"
    >
      @if (tab() === 'carta') {
        <form
          class="grid grid-cols-1 gap-3 py-4 lg:grid-cols-2"
          (submit)="guardar(); $event.preventDefault()"
        >
          <section class="rounded-xl border border-slate-200 bg-white p-4">
            <h3 class="flex items-center gap-2 text-sm font-bold text-slate-900">
              <i class="bi bi-shop text-accent-600"></i>
              Identidad de la carta
            </h3>

            <div class="mt-3 space-y-3">
              <div>
                <label class="mb-1 block text-xs font-semibold text-slate-600">
                  Nombre comercial
                </label>
                <input
                  type="text"
                  [formField]="$any(configForm.nombre_comercial)"
                  placeholder="Ej: Pollería El Buen Sabor"
                  class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-accent-500 focus:ring-2 focus:ring-accent-500/20"
                />
                <p class="mt-1 text-[11px] text-slate-400">
                  Si lo dejas vacío se usará {{ empresa()?.nombre }}.
                </p>
              </div>

              <div>
                <label class="mb-1 block text-xs font-semibold text-slate-600">
                  Descripción breve
                </label>
                <textarea
                  rows="2"
                  [formField]="$any(configForm.descripcion)"
                  placeholder="Lo mejor de la casa, preparado al momento…"
                  class="w-full resize-none rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-accent-500 focus:ring-2 focus:ring-accent-500/20"
                ></textarea>
              </div>

              <div>
                <label class="mb-1 block text-xs font-semibold text-slate-600">Logo (URL)</label>
                <input
                  type="text"
                  inputmode="url"
                  [formField]="$any(configForm.logo_url)"
                  placeholder="https://…"
                  class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-accent-500 focus:ring-2 focus:ring-accent-500/20"
                />
                <p class="mt-1 text-[11px] text-slate-400">
                  Si lo dejas vacío se usará el logo de la empresa.
                </p>
                @if (logoPreview(); as logo) {
                  <img
                    [src]="logo"
                    alt="Vista previa del logo"
                    class="mt-2 h-16 w-16 rounded-xl border border-slate-200 bg-slate-50 object-contain p-1"
                    (error)="onImageError($event)"
                  />
                }
              </div>

              <div>
                <label class="mb-1 block text-xs font-semibold text-slate-600">Banner (URL)</label>
                <input
                  type="text"
                  inputmode="url"
                  [formField]="$any(configForm.banner_url)"
                  placeholder="https://…"
                  class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-accent-500 focus:ring-2 focus:ring-accent-500/20"
                />
                @if (bannerPreview(); as banner) {
                  <img
                    [src]="banner"
                    alt="Vista previa del banner"
                    class="mt-2 h-20 w-full rounded-xl border border-slate-200 object-cover"
                    (error)="onImageError($event)"
                  />
                }
              </div>

              <div>
                <label class="mb-1 block text-xs font-semibold text-slate-600">
                  Mensaje de bienvenida
                </label>
                <textarea
                  rows="2"
                  [formField]="$any(configForm.mensaje_bienvenida)"
                  placeholder="Ej: Pide tu combo favorito y recíbelo en casa."
                  class="w-full resize-none rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-accent-500 focus:ring-2 focus:ring-accent-500/20"
                ></textarea>
              </div>
            </div>
          </section>

          <section class="rounded-xl border border-slate-200 bg-white p-4">
            <h3 class="flex items-center gap-2 text-sm font-bold text-slate-900">
              <i class="bi bi-link-45deg text-accent-600"></i>
              Enlace y contacto
            </h3>

            <div class="mt-3 space-y-3">
              <div>
                <label class="mb-1 block text-xs font-semibold text-slate-600">
                  Enlace público
                </label>
                @if (empresa()?.pidelo_endpoint) {
                  <div class="flex items-center gap-2 rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-600">
                    <i class="bi bi-link-45deg shrink-0 text-slate-400"></i>
                    <span class="truncate">{{ empresa()?.pidelo_endpoint }}</span>
                  </div>
                  <p class="mt-1 text-[11px] text-slate-400">
                    Configurado por el administrador de VentaClick.
                  </p>
                } @else if (enlacePublico()) {
                  <div class="flex items-center gap-2 rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-600">
                    <i class="bi bi-link-45deg shrink-0 text-slate-400"></i>
                    <span class="truncate">{{ enlacePublico() }}</span>
                  </div>
                  <p class="mt-1 text-[11px] text-slate-400">
                    Enlace actual. El administrador aún no define la URL definitiva.
                  </p>
                } @else {
                  <div class="rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-xs leading-relaxed text-amber-700">
                    <i class="bi bi-info-circle mr-1"></i>
                    El administrador aún no configuró el enlace público de tu carta.
                    Contáctalo para activar Pidelo.
                  </div>
                }
              </div>

              <div>
                <label class="mb-1 block text-xs font-semibold text-slate-600">
                  WhatsApp de pedidos
                </label>
                <input
                  type="tel"
                  [formField]="$any(configForm.whatsapp)"
                  placeholder="51987654321"
                  class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-accent-500 focus:ring-2 focus:ring-accent-500/20"
                />
                <p class="mt-1 text-[11px] text-slate-400">
                  Si lo dejas vacío se usará el teléfono de la empresa:
                  {{ empresa()?.telefono || 'no configurado' }}.
                </p>
              </div>

              <div>
                <label class="mb-1 block text-xs font-semibold text-slate-600">Dirección</label>
                <input
                  type="text"
                  [formField]="$any(configForm.direccion)"
                  [placeholder]="empresa()?.direccion || 'Av. Principal 123, Lima'"
                  class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-accent-500 focus:ring-2 focus:ring-accent-500/20"
                />
                <p class="mt-1 text-[11px] text-slate-400">
                  Si lo dejas vacío se usará la dirección de la empresa.
                </p>
              </div>

              <label class="flex cursor-pointer items-center justify-between rounded-lg border border-slate-200 px-3 py-2.5">
                <span class="flex items-center gap-2 text-sm font-medium text-slate-700">
                  <i class="bi bi-globe text-accent-600"></i>
                  Carta publicada
                </span>
                <input
                  type="checkbox"
                  [formField]="$any(configForm.publicado)"
                  class="h-5 w-5 accent-teal-600"
                />
              </label>
              <p class="text-[11px] leading-relaxed text-slate-400">
                Los clientes podrán ver la carta sin iniciar sesión. Si está en borrador, el enlace
                mostrará “Carta no disponible”.
              </p>
            </div>
          </section>

          <section class="rounded-xl border border-slate-200 bg-white p-4 lg:col-span-2">
            <h3 class="flex items-center gap-2 text-sm font-bold text-slate-900">
              <i class="bi bi-truck text-accent-600"></i>
              Pedidos y modalidades
            </h3>

            <div class="mt-3">
              <p class="mb-2 text-xs font-semibold text-slate-600">Costo de delivery</p>
              <div class="grid gap-2 sm:grid-cols-2">
                <button
                  type="button"
                  [class]="modoDeliveryClass(configModel().costo_delivery_habilitado)"
                  [attr.aria-pressed]="configModel().costo_delivery_habilitado"
                  (click)="setCostoDeliveryHabilitado(true)"
                >
                  <span class="flex items-center gap-2 text-sm font-semibold text-slate-800">
                    <i class="bi bi-cash-coin text-accent-600"></i>
                    Costo fijo
                  </span>
                  <span class="mt-0.5 block text-xs leading-relaxed text-slate-500">
                    Cobra un monto fijo y súmalo al total.
                  </span>
                </button>

                <button
                  type="button"
                  [class]="modoDeliveryClass(!configModel().costo_delivery_habilitado)"
                  [attr.aria-pressed]="!configModel().costo_delivery_habilitado"
                  (click)="setCostoDeliveryHabilitado(false)"
                >
                  <span class="flex items-center gap-2 text-sm font-semibold text-slate-800">
                    <i class="bi bi-geo-alt text-amber-500"></i>
                    A coordinar
                  </span>
                  <span class="mt-0.5 block text-xs leading-relaxed text-slate-500">
                    La tienda define el costo según la ubicación.
                  </span>
                </button>
              </div>
              <p class="mt-1 text-[11px] leading-relaxed text-slate-400">
                @if (configModel().costo_delivery_habilitado) {
                  El monto se sumará al total del pedido.
                } @else {
                  El cliente verá “Delivery a coordinar” y el total no incluirá delivery.
                }
              </p>
            </div>

            <div class="mt-3 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
              <label class="flex cursor-pointer items-center justify-between rounded-lg border border-slate-200 px-3 py-2.5">
                <span class="text-sm font-medium text-slate-700">Delivery</span>
                <input
                  type="checkbox"
                  [formField]="$any(configForm.delivery_habilitado)"
                  class="h-5 w-5 accent-teal-600"
                />
              </label>

              <label class="flex cursor-pointer items-center justify-between rounded-lg border border-slate-200 px-3 py-2.5">
                <span class="text-sm font-medium text-slate-700">Recojo</span>
                <input
                  type="checkbox"
                  [formField]="$any(configForm.recojo_habilitado)"
                  class="h-5 w-5 accent-teal-600"
                />
              </label>

              <div>
                <label class="mb-1 block text-xs font-semibold text-slate-600">
                  Monto del delivery
                </label>
                @if (configModel().costo_delivery_habilitado) {
                  <input
                    type="number"
                    min="0"
                    step="0.01"
                    [formField]="$any(configForm.costo_delivery)"
                    placeholder="0.00"
                    class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 outline-none transition focus:border-accent-500 focus:ring-2 focus:ring-accent-500/20"
                  />
                  <p class="mt-1 text-[11px] leading-relaxed text-slate-400">
                    El cliente verá
                    <span class="font-semibold text-slate-600">Delivery {{ costoDeliveryPreview() }}</span>.
                  </p>
                } @else {
                  <div class="w-full rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-700">
                    A coordinar según la ubicación
                  </div>
                  <p class="mt-1 text-[11px] leading-relaxed text-amber-600">
                    El total se mostrará sin delivery.
                  </p>
                }
              </div>

              <div>
                <label class="mb-1 block text-xs font-semibold text-slate-600">
                  Pedido mínimo
                </label>
                <input
                  type="number"
                  min="0"
                  step="0.01"
                  [formField]="$any(configForm.pedido_minimo)"
                  class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 outline-none transition focus:border-accent-500 focus:ring-2 focus:ring-accent-500/20"
                />
              </div>
            </div>

            <div class="mt-3">
              <label class="mb-1 block text-xs font-semibold text-slate-600">
                Mensaje al final del pedido
              </label>
              <textarea
                rows="2"
                [formField]="$any(configForm.mensaje_pedido)"
                placeholder="Ej: Aceptamos Yape, Plin y efectivo. ¡Gracias por tu pedido!"
                class="w-full resize-none rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-accent-500 focus:ring-2 focus:ring-accent-500/20"
              ></textarea>
            </div>
          </section>

          <div class="sticky bottom-0 z-10 flex w-full flex-col gap-2 border-t border-slate-200 bg-white/95 py-3 backdrop-blur sm:flex-row sm:items-center sm:justify-between lg:col-span-2">
            <p class="text-[11px] leading-relaxed text-slate-400">
              Los cambios se aplican a la carta pública al guardar.
            </p>
            <div class="flex w-full sm:w-auto [&_button]:w-full sm:[&_button]:w-auto">
              <app-button
                type="submit"
                label="Guardar configuración"
                icon="bi bi-check-lg"
                variant="primary"
                [loading]="guardando()"
                [disabled]="guardando()"
              />
            </div>
          </div>
        </form>
      } @else if (tab() === 'productos') {
        <div class="py-4">
          <div class="mb-3 flex flex-col gap-2 sm:flex-row sm:items-center">
            <app-input-buscador
              placeholder="Buscar producto…"
              [valor]="busqueda()"
              (valorChange)="busqueda.set($event)"
              class="flex-1"
            />
            <div class="flex gap-1.5">
              @for (opcion of filtros; track opcion.value) {
                <button
                  type="button"
                  [class]="chipClass(filtro() === opcion.value)"
                  (click)="setFiltro(opcion.value)"
                >
                  {{ opcion.label }}
                  <span class="ml-1 opacity-70">{{ conteoFiltro(opcion.value) }}</span>
                </button>
              }
            </div>
          </div>

          @if (productos().length === 0) {
            <div class="rounded-xl border border-dashed border-slate-300 bg-white px-6 py-10 text-center text-sm text-slate-500">
              <i class="bi bi-box-seam mb-2 block text-2xl text-slate-300"></i>
              <p>Crea productos en Gestión → Productos para armar tu carta.</p>
              <a
                routerLink="/panel/gestion/producto"
                class="mt-3 inline-flex items-center gap-1.5 rounded-lg border border-slate-200 bg-white px-3 py-2 text-xs font-semibold text-slate-700 transition hover:bg-slate-50"
              >
                <i class="bi bi-box-seam"></i>
                Ir a Productos
              </a>
            </div>
          } @else {
            <div class="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-3">
              @for (producto of productosFiltrados(); track producto.id) {
                <article
                  class="flex flex-col gap-3 rounded-xl border border-slate-200 bg-white p-3 transition-shadow hover:shadow-md"
                  [class.opacity-70]="!producto.visible"
                >
                  <div class="flex gap-3">
                    @if (imagenProducto(producto.url_imagen); as imagen) {
                      <img
                        [src]="imagen"
                        [alt]="producto.nombre"
                        loading="lazy"
                        class="h-16 w-16 shrink-0 rounded-lg object-cover"
                        (error)="onImageError($event)"
                      />
                    } @else {
                      <div class="flex h-16 w-16 shrink-0 items-center justify-center rounded-lg bg-slate-100">
                        <i class="bi bi-image-alt text-2xl text-slate-300"></i>
                      </div>
                    }

                    <div class="min-w-0 flex-1">
                      <div class="flex items-start justify-between gap-2">
                        <p class="truncate text-sm font-semibold text-slate-900">{{ producto.nombre }}</p>
                        <div class="flex shrink-0 flex-wrap justify-end gap-1">
                          @if (!producto.activo) {
                            <app-tag value="Inactivo" severity="danger" />
                          }
                          @if (!producto.visible) {
                            <app-tag value="Oculto" severity="secondary" />
                          }
                        </div>
                      </div>
                      <p class="truncate text-xs text-slate-500">
                        {{ producto.categoria_nombre || 'Sin categoría' }}
                      </p>
                      <div class="mt-1 flex items-baseline gap-1.5">
                        <span class="text-sm font-bold text-accent-600">
                          {{ moneda(producto.precio_efectivo) }}
                        </span>
                        @if (producto.precio_publico !== null) {
                          <span class="text-[11px] text-slate-400 line-through">
                            {{ moneda(producto.precio_venta) }}
                          </span>
                        }
                      </div>
                    </div>
                  </div>

                  <div class="flex flex-wrap items-center gap-1.5">
                    <button
                      type="button"
                      [class]="pillClass(producto.visible, 'green')"
                      [disabled]="!producto.activo && !producto.visible"
                      [attr.aria-pressed]="producto.visible"
                      (click)="toggleProducto(producto, 'visible', !producto.visible)"
                    >
                      <i class="bi bi-eye mr-0.5"></i>{{ producto.visible ? 'Visible' : 'Oculto' }}
                    </button>
                    <button
                      type="button"
                      [class]="pillClass(producto.disponible, 'amber')"
                      [attr.aria-pressed]="producto.disponible"
                      (click)="toggleProducto(producto, 'disponible', !producto.disponible)"
                    >
                      <i class="bi bi-check-circle mr-0.5"></i>
                      {{ producto.disponible ? 'Disponible' : 'Agotado' }}
                    </button>
                    <button
                      type="button"
                      [class]="pillClass(producto.destacado, 'violet')"
                      [attr.aria-pressed]="producto.destacado"
                      (click)="toggleProducto(producto, 'destacado', !producto.destacado)"
                    >
                      <i class="bi bi-star mr-0.5"></i>
                      {{ producto.destacado ? 'Destacado' : 'Destacar' }}
                    </button>
                  </div>

                  <div class="grid grid-cols-[1fr_78px] gap-2 border-t border-slate-100 pt-2">
                    <div>
                      <label class="text-[10px] font-semibold uppercase tracking-wide text-slate-400">
                        Precio carta
                      </label>
                      <div class="mt-0.5 flex items-center gap-1">
                        <input
                          type="number"
                          min="0"
                          step="0.01"
                          [value]="producto.precio_publico ?? ''"
                          [placeholder]="producto.precio_venta.toString()"
                          class="min-w-0 flex-1 rounded-lg border border-slate-200 bg-white px-2 py-1.5 text-xs text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-accent-500 focus:ring-2 focus:ring-accent-500/20"
                          (change)="cambiarPrecio(producto, $event)"
                        />
                        @if (producto.precio_publico !== null) {
                          <button
                            type="button"
                            class="flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-slate-400 transition hover:bg-slate-100 hover:text-slate-700"
                            (click)="restablecerPrecio(producto)"
                            title="Usar precio base"
                            aria-label="Usar precio base"
                          >
                            <i class="bi bi-arrow-counterclockwise text-xs"></i>
                          </button>
                        }
                      </div>
                    </div>

                    <div>
                      <label class="text-[10px] font-semibold uppercase tracking-wide text-slate-400">
                        Orden
                      </label>
                      <input
                        type="number"
                        min="0"
                        max="9999"
                        step="1"
                        [value]="producto.orden"
                        class="mt-0.5 w-full rounded-lg border border-slate-200 bg-white px-2 py-1.5 text-xs text-slate-900 outline-none transition focus:border-accent-500 focus:ring-2 focus:ring-accent-500/20"
                        (change)="cambiarOrden(producto, $event)"
                      />
                    </div>
                  </div>
                </article>
              } @empty {
                <div class="col-span-full rounded-xl border border-dashed border-slate-300 bg-white py-10 text-center text-sm text-slate-500">
                  No hay productos que coincidan con la búsqueda.
                </div>
              }
            </div>
          }
        </div>
      } @else {
        <div class="py-4">
          @if (categorias().length === 0) {
            <div class="rounded-xl border border-dashed border-slate-300 bg-white px-6 py-10 text-center text-sm text-slate-500">
              <i class="bi bi-tags mb-2 block text-2xl text-slate-300"></i>
              <p>Crea categorías en Gestión → Categorías para organizar tu carta.</p>
              <a
                routerLink="/panel/gestion/categoria"
                class="mt-3 inline-flex items-center gap-1.5 rounded-lg border border-slate-200 bg-white px-3 py-2 text-xs font-semibold text-slate-700 transition hover:bg-slate-50"
              >
                <i class="bi bi-tags"></i>
                Ir a Categorías
              </a>
            </div>
          } @else {
            <div class="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-3">
              @for (categoria of categorias(); track categoria.id) {
                <div
                  class="flex items-center gap-3 rounded-xl border border-slate-200 bg-white p-4 transition-shadow hover:shadow-md"
                  [class.opacity-70]="!categoria.visible"
                >
                  <div class="rounded-lg bg-accent-50 p-2.5">
                    <i class="bi bi-tags text-lg text-accent-600"></i>
                  </div>

                  <div class="min-w-0 flex-1">
                    <p class="truncate text-sm font-semibold text-slate-900">{{ categoria.nombre }}</p>
                    <p class="text-xs text-slate-500">
                      {{ categoria.cantidad_productos }}
                      {{ categoria.cantidad_productos === 1 ? 'producto' : 'productos' }}
                    </p>

                    <div class="mt-2 flex flex-wrap items-center gap-2">
                      <button
                        type="button"
                        [class]="pillClass(categoria.visible, 'green')"
                        [attr.aria-pressed]="categoria.visible"
                        (click)="toggleCategoria(categoria, !categoria.visible)"
                      >
                        {{ categoria.visible ? 'Visible' : 'Oculta' }}
                      </button>

                      <label class="flex items-center gap-1 text-[10px] font-semibold uppercase tracking-wide text-slate-400">
                        Orden
                        <input
                          type="number"
                          min="0"
                          max="9999"
                          step="1"
                          [value]="categoria.orden"
                          class="w-16 rounded-md border border-slate-200 bg-white px-1.5 py-1 text-xs text-slate-900 outline-none transition focus:border-accent-500 focus:ring-2 focus:ring-accent-500/20"
                          (change)="cambiarOrdenCategoria(categoria, $event)"
                        />
                      </label>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      }
    </app-tabs>
  }
</div>
